jQuery(document).ready(function() {
	// load slider for Headslider

	
jQuery('.startslider').slick({
  dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  fade: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 4400 
}); 


//jQuery("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 466 841.9'><defs><rect x='21' y='13.9' width='429' height='813.6'/></defs><clipPath><use xlink:href='#SVGID_1_'/></clipPath><path d='M443 403.6L60.2 20.9c-9-9-23.5-9-32.5 0 -9 9-9 23.5 0 32.5l366.4 366.4L27.8 786.2c-9 9-9 23.5 0 32.5 4.4 4.4 10.4 6.8 16.2 6.8 5.8 0 11.7-2.2 16.1-6.8l382.8-382.7C451.8 427.1 451.8 412.5 443 403.6L443 403.6zM443 403.6' clip-path='url(#SVGID_2_)'/></svg>").appendTo( ".slick-next , .slick-prev");
	

});